export default __webpack_public_path__ + "static/media/orderbook_navicon-light.f333fc04.svg";